/* eslint-disable no-unused-vars */
import { Button, Grid } from "@mui/material";
import { green, orange, purple } from "@mui/material/colors";
import { createMuiTheme, ThemeProvider } from "@mui/material/styles";
import { makeStyles, withStyles } from "@mui/styles";

import BackspaceIcon from "@mui/icons-material/Backspace";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({});

const theme = createMuiTheme({
  status: {
    danger: orange[500],
  },
});

const DigitButton = withStyles((theme: Theme) => ({
  root: {
    width: "50px",
    height: "50px",
    fontSize: "1.5rem",
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
}))(Button);

const EnterButton = withStyles((theme: Theme) => ({
  root: {
    width: "50px",
    height: "50px",
    fontSize: "1rem",
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: orange[500],
    "&:hover": {
      backgroundColor: orange[700],
    },
  },
}))(Button);
const ActionButton = withStyles((theme: Theme) => ({
  root: {
    width: "100%",
    height: "50px",
    fontSize: "1rem",
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
}))(Button);
let prevKeyTime = 0;
export default function PaymentDigitPanel(props) {
  const { t } = useTranslation();
  const translate = t;
  const classes = useStyles();
  const [digits, setDigits] = useState("");

  /*props.pRefs.digitPanel = {
    parentEvent: parentEvent,
  };

  function parentEvent(event, value1, value2, value3) {
    if (event === "onKeyPressed") {
      onKeyPressed(value1);
    }
  }*/
  function onKeyPressed(value) {
    props.onKeyPressed(value);
  }
  return (
    <ThemeProvider theme={theme}>
      <Grid container style={{ height: "150px" }}>
        <Grid item xs={12}>
          <table>
            <tbody>
              <tr>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("1");
                    }}
                  >
                    1
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("2");
                    }}
                  >
                    2
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("3");
                    }}
                  >
                    3
                  </DigitButton>
                </td>
              </tr>
              <tr>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("4");
                    }}
                  >
                    4
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("5");
                    }}
                  >
                    5
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("6");
                    }}
                  >
                    6
                  </DigitButton>
                </td>
              </tr>
              <tr>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("7");
                    }}
                  >
                    7
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("8");
                    }}
                  >
                    8
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("9");
                    }}
                  >
                    9
                  </DigitButton>
                </td>
              </tr>
              <tr>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed(".");
                    }}
                  >
                    .
                  </DigitButton>
                </td>
                <td>
                  <DigitButton
                    onClick={() => {
                      onKeyPressed("0");
                    }}
                  >
                    0
                  </DigitButton>
                </td>
                <td>
                  <EnterButton
                    onClick={() => {
                      onKeyPressed("Backspace");
                    }}
                  >
                    <BackspaceIcon />
                  </EnterButton>
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
